import React from 'react';
import { Badge, HStack, Text } from '@chakra-ui/react';
import { SessionDataType } from '../../../../models/m6-2';

const LABEL: Record<SessionDataType, string> = {
  gps_full: 'GPS completo',
  cardio_only: 'Cardio puro',
  running_cycling: 'Corsa/Cycling',
  manual: 'Manuale',
};

const COLOR: Record<SessionDataType, string> = {
  gps_full: 'blue',
  cardio_only: 'red',
  running_cycling: 'green',
  manual: 'gray',
};

const ICON: Record<SessionDataType, string> = {
  gps_full: '📡',
  cardio_only: '❤️',
  running_cycling: '🏃',
  manual: '✍️',
};

interface Props {
  dataType: SessionDataType;
  confidence?: number;
  compact?: boolean;
}

/**
 * Badge tipo dato rilevato da AutoDetectService (M6.2 B12).
 */
export function DataTypeBadge({ dataType, confidence, compact }: Props) {
  const pct = confidence !== undefined ? Math.round(confidence * 100) : null;
  return (
    <Badge colorPalette={COLOR[dataType]} variant="subtle" px={2} py={1}>
      <HStack gap={1}>
        <Text fontSize="sm">{ICON[dataType]}</Text>
        {!compact && <Text fontSize="sm">{LABEL[dataType]}</Text>}
        {pct !== null && (
          <Text fontSize="xs" opacity={0.7}>
            {pct}%
          </Text>
        )}
      </HStack>
    </Badge>
  );
}
